// extracted by mini-css-extract-plugin
module.exports = {"provider-card":"_2ozG9a4iQr1fyRzP7kHcQB"};